import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type SaveWorkflowRuleMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.WorkflowRuleInput;
}>;

export type SaveWorkflowRuleMutationResult = { __typename?: 'Mutation' } & {
  saveWorkflowRule?: GraphQLTypes.Maybe<
    { __typename?: 'SaveWorkflowRulePayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const SaveWorkflowRuleDocument = /*#__PURE__*/ gql`
  mutation saveWorkflowRule($input: WorkflowRuleInput!) {
    saveWorkflowRule(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useSaveWorkflowRuleMutation__
 *
 * To run a mutation, you first call `useSaveWorkflowRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorkflowRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWorkflowRuleMutation, { data, loading, error }] = useSaveWorkflowRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveWorkflowRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<SaveWorkflowRuleMutationResult, SaveWorkflowRuleMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<SaveWorkflowRuleMutationResult, SaveWorkflowRuleMutationVariables>(SaveWorkflowRuleDocument, options);
}
export type SaveWorkflowRuleMutationHookResult = ReturnType<typeof useSaveWorkflowRuleMutation>;
